export class TransactionReviewError extends Error {
    constructor(transactionReviewUrl) {
        super('transaction review error');
        this.name = "TransactionReviewError";
        this.transactionReviewUrl = transactionReviewUrl;
    }
}
